module.exports = __webpack_public_path__ + "img/fi-rr-resources.e25939ba.svg";